var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "navbar" }, [
    _c(
      "div",
      { staticClass: "right-menu" },
      [
        _vm.device !== "mobile" ? void 0 : _vm._e(),
        _c(
          "el-dropdown",
          {
            staticClass: "avatar-container right-menu-item hover-effect",
            attrs: { trigger: "click" },
          },
          [
            _c(
              "div",
              {
                staticClass: "avatar-wrapper",
                staticStyle: { "margin-top": "0px" },
              },
              [
                _vm._v(" " + _vm._s(_vm.user.nickName) + " "),
                _c("i", {
                  staticClass: "el-icon-caret-bottom",
                  staticStyle: { top: "20px" },
                }),
              ]
            ),
            _c(
              "el-dropdown-menu",
              { attrs: { slot: "dropdown" }, slot: "dropdown" },
              [
                _c(
                  "span",
                  {
                    staticStyle: { display: "block" },
                    on: { click: _vm.open },
                  },
                  [
                    _c("el-dropdown-item", { attrs: { divided: "" } }, [
                      _vm._v(" Logout "),
                    ]),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }